<template>
    <div class="grid">
        <div class="col-12">
            <div class="card" v-if="permission?.includes('read')">
                <Toast />
                <Error :errors="errors" />

                <Fieldset legend="Filter" :toggleable="true" :collapsed="true" class="mb-3">
                    <Filter @submit="getDataTable()" ref="filter" />
                </Fieldset>

                <DataTable :value="dataTable" responsiveLayout="scroll" :loading="loading" dataKey="number"
                    @sort="onSort($event)" :resizableColumns="true">
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <div>
                                <Button :loading="loadingExcel" label="Export Excel" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('xlsx')" />
                                <Button :loading="loadingCsv" label="Export CSV" icon="pi pi-file-excel"
                                    class="p-button p-button-success mr-2 my-1 inline-block"
                                    @click="exportExcelCSV('csv')" />
                            </div>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="search" placeholder="Cari..." @keyup.enter="getDataTable" />
                            </span>
                        </div>
                    </template>
                    <Column field="number" header="No." :style="{ width: '20px' }">
                        <template #body="slotProps">
                            {{ slotProps.data.number }}
                        </template>
                    </Column>
                    <Column field="region_name" header="Region">
                        <template #body="slotProps">
                            {{ slotProps.data.region_name }}
                        </template>
                    </Column>
                    <Column field="distributor_code" header="Distributor Code">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_code }}
                        </template>
                    </Column>
                    <Column field="distributor_name" header="Distributor Name">
                        <template #body="slotProps">
                            {{ slotProps.data.distributor_name }}
                        </template>
                    </Column>
                    <Column field="user_code" header="ASM Code">
                        <template #body="slotProps">
                            {{ slotProps.data.user_code }}
                        </template>
                    </Column>
                    <Column field="user_name" header="ASM Name">
                        <template #body="slotProps">
                            {{ slotProps.data.user_name }}
                        </template>
                    </Column>
                    <Column field="subject_name" header="Training Subject">
                        <template #body="slotProps">
                            {{ slotProps.data.subject_name }}
                        </template>
                    </Column>
                    <Column field="training_documentation_url" header="Training Documentation">
                        <template #body="slotProps">
                            <Image v-if="slotProps.data.training_documentation_url != 'null'" :src="slotProps.data.training_documentation_url" :alt="slotProps.data.training_documentation_url" width="100" preview />
                        </template>
                    </Column>
                    <Column field="training_feedback" header="Training Feedback">
                        <template #body="slotProps">
                            {{ slotProps.data.training_feedback }}
                        </template>
                    </Column>
                    <Column field="training_date" header="Training Date">
                        <template #body="slotProps">
                            {{ slotProps.data.training_date }}
                        </template>
                    </Column>
                    <Column field="training_time" header="Training Time">
                        <template #body="slotProps">
                            {{ slotProps.data.training_time }}
                        </template>
                    </Column>
                    <Column field="training_latitude" header="Training Latitude">
                        <template #body="slotProps">
                            {{ slotProps.data.training_latitude }}
                        </template>
                    </Column>
                    <Column field="training_longitude" header="Training Longitude">
                        <template #body="slotProps">
                            {{ slotProps.data.training_longitude }}
                        </template>
                    </Column>
                    <Column field="training_gps_address" header="Training GPS Address">
                        <template #body="slotProps">
                            {{ slotProps.data.training_gps_address }}
                        </template>
                    </Column>
                    <Column field="total_salesman" header="Total Salesman">
                        <template #body="slotProps">
                            {{ slotProps.data.total_salesman }}
                        </template>
                    </Column>
                    <Column field="Salesman Name" header="Salesman">
                        <template #body="slotProps">
                            {{ slotProps.data.salesman_name }}
                        </template>
                    </Column>
                    <Column field="training_status" header="Training Status">
                        <template #body="slotProps">
                            {{ slotProps.data.training_status }}
                        </template>
                    </Column>
                    <Column header="Aksi" headerStyle="min-width:10rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                :disabled="slotProps.data.training_status !== 'pending'"
                                @click="editItem(slotProps.data)" v-if="permission.includes('update')" />
                        </template>
                    </Column>

                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait. </template>
                    <template #footer>
                        In total there are {{ totalItemsCount ? totalItemsCount : 0 }} data.
                    </template>
                </DataTable>

                <Paginator v-model:rows="rows" v-model:first="offset" :totalRecords="totalItemsCount"
                    :rowsPerPageOptions="[10, 20, 30]">
                    <template>
                        {{ totalItemsCount }}
                    </template>
                </Paginator>

                <Dialog v-model:visible="editItemDialog" :style="{ width: '450px' }" header="Update Training Status"
                    :modal="true" class="p-fluid">
                    <div class="field">
                        <label>Status</label>
                        <Dropdown ref="dstatus" v-model="item.status" :options="dataDropdownStatus"
                            :class="{ 'p-invalid': errorEdit.status }" optionLabel="name" optionValue="code"
                            placeholder="Pilih Status" />
                        <small class="p-invalid" style="color: red" v-if="errorEdit.status">{{
                            errorEdit.status[0]
                            }}</small>
                    </div>

                    <template #footer>
                        <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
                        <Button label="Simpan" icon="pi pi-check" class="p-button-text" @click="updateItem"
                            :loading="loadingEdit" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { numberingDatatable } from "../../utils/helpers";
import Filter from "../../components/report/training/Filter.vue";
import Error from "../../components/Error.vue";

export default {
    components: {
        Filter: Filter,
        Error: Error,
    },
    data() {
        return {
            // loading
            loading: false,
            loadingExcel: false,
            loadingCsv: false,

            //datatables
            data: null,
            dataTable: null,
            rows: 10,
            search: null,
            offset: null,
            field: null,
            sort: null,
            page: null,
            totalItemsCount: 0,

            //datadropdown
            dataDropdownStatus: [
                { name: 'Success', code: 'success' },
                { name: 'Failed', code: 'failed' },
            ],

            // edit
            item: {},
            editItemDialog: false,

        };
    },
    mounted() {
        const waitForRef = setInterval(() => {
            if (this.$refs.filter) {
                clearInterval(waitForRef);
                this.getDataTable();
            }
        }, 100);
        this.$store.commit("setErrors", {});
    },
    watch: {
        offset() {
            this.getDataTable();
        },
        rows() {
            this.getDataTable();
        },
    },
    computed: {
        ...mapGetters(["errors", "errorEdit"]),
        ...mapGetters("auth", ["permission"]),
    },
    methods: {
        formatDate(value) {
            if (value) {
                return moment.utc(value).format("DD-MM-YYYY");
            }
        },
        // DATATABLE
        getDataTable() {
            this.loading = true;
            if (this.$refs?.filter) {
                this.$refs.filter.loading = true;
            }
            console.log('filter', this.$refs?.filter)
            this.page = this.offset / this.rows + 1;

            this.axios({
                method: "GET",
                url: process.env.VUE_APP_ROOT_API + "web/training",
                params: {
                    search: this.search,
                    per_page: this.rows,
                    page: this.page,
                    order_by: this.field,
                    sort_by: this.sort,
                    region_id: this.$refs?.filter?.filters.region_id,
                    distributor_id: this.$refs?.filter?.filters.distributor_id,
                    user_code: this.$refs?.filter?.filters.user_code,
                    start_date: this.$refs?.filter?.period_start_label,
                    end_date: this.$refs?.filter?.period_end_label,
                },
            })
                .then((res) => {
                    this.data = res.data.data.data;
                    this.dataTable = numberingDatatable(
                        res.data.data.data,
                        this.page,
                        this.rows
                    );
                    this.totalItemsCount = res.data.data.total;
                    this.rows = parseInt(res.data.data.per_page);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$refs.filter.loading = false;
                });
        },
        onSort(event) {
            this.field = event.sortField;
            this.sort = event.sortOrder == "1" ? "ASC" : "DESC";
            this.getDataTable();
        },
        // EXPORT
        exportExcelCSV(ext) {
            if (
                this.$refs?.filter?.period_start_label !== null &&
                this.$refs?.filter?.period_end_label !== null &&
                this.$refs?.filter?.period_start_label !== "Invalid date" &&
                this.$refs?.filter?.period_end_label !== "Invalid date"
            ) {
                if (ext == "xlsx") {
                    this.loadingExcel = true;
                } else if (ext == "csv") {
                    this.loadingCsv = true;
                }

                this.axios({
                    method: "GET",
                    url: process.env.VUE_APP_ROOT_API + "web/training/export",
                    responseType: "blob",
                    params: {
                        ext: ext,
                        region_id: this.$refs?.filter?.filters.region_id,
                        distributor_id: this.$refs?.filter?.filters.distributor_id,
                        user_code: this.$refs?.filter?.filters.user_code,
                        start_date: this.$refs?.filter?.period_start_label,
                        end_date: this.$refs?.filter?.period_end_label,
                    },
                })
                    .then((response) => {
                        let fileUrl = window.URL.createObjectURL(response.data);
                        let fileLink = document.createElement("a");

                        fileLink.href = fileUrl;

                        fileLink.setAttribute("download", "Report Training Export." + ext);

                        document.body.appendChild(fileLink);

                        fileLink.click();

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    })
                    .catch((err) => {
                        console.log(err);

                        if (ext == "xlsx") {
                            this.loadingExcel = false;
                        } else if (ext == "csv") {
                            this.loadingCsv = false;
                        }
                    });
            } else {
                alert("Pastikan rentang waktu sudah benar atau tidak kosong");
            }
        },
        // EDIT
        editItem(item) {
            this.item = item;
            this.editItemDialog = true;
            this.$store.commit('setErrorEdit', {});

        },
        hideDialog() {
            this.editItemDialog = false;
            this.submitted = false;
        },
        updateItem() {
            this.loadingEdit = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/training/update-status',
                data: {
                    "training_id": this.item.training_id,
                    "status": this.item.status,
                },
            })
                .then((res) => {
                    this.loadingEdit = false;
                    if (res) {
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Berhasil Diupdate', life: 3000, });
                        this.$store.commit('setErrors', {});
                        this.$store.commit('setErrorEdit', {});
                        this.item = {};
                        this.editItemDialog = false;
                        this.getDataTable();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loadingEdit = false;
                    this.$store.commit('setErrorEdit', err.response.data.data);
                    this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Gagal Diperbarui', life: 3000, });
                });
        },
    },
};
</script>
